var paragraph_default = {
  "fontElementMap": "Z7vdZ",
  "elementSpacing": "GF80u",
  "text": "o0STb GF80u",
  "child": "B-fpk"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
